<template>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group col-md-3 required-field" :class="{ 'has-error' : errors.first('data CMJ')}" style="margin-right:0;margin-left:0;">
        <label class="control-label">Data do CMJ</label>
        <div class="input-group">
          <!-- Alteração da exibição das datas CMJ nas telas de Projeto. Suporte 63.555 -->
          <input v-if="this.$router.currentRoute.name === 'projeto'" type="date" class="form-control " ref="dataCMJ" name="data do CMJ" v-model="analise.dt_data_cmj"
                   data-vv-as="data do CMJ" v-validate="'required|dateeqpast'">

          <input v-else type="text" class="form-control" ref="dataCMJ" name="data do CMJ" v-model="analise.dt_data_cmj"
                 placeholder="__ /__ /____" v-mask="'##/##/####'" data-vv-as="data do CMJ" v-validate="'required|dateeqpast|date_format:dd/MM/yyyy'">
        </div>
        <span v-if="errors.first('data do CMJ')" class="label label-danger"> {{ errors.first('data do CMJ') }}</span>
      </div>

      <div class="form-group col-md-3 required-field" :class="{ 'has-error' : errors.first('cmj')}" style="margin-right:0;margin-left:0;">
        <label class="control-label">Número do CMJ</label>
        <input v-model="analise.ds_cmj" name="cmj" class="form-control"
               type="text" maxlength="255"
               placeholder="Número do CMJ" v-validate="'required|max:255'">
        <span v-if="errors.first('cmj')" class="label label-danger"> {{ errors.first('cmj') }}</span>
      </div>

      <div class="form-group col-md-3 required-field" :class="{ 'has-error' : errors.first('data parecer')}" style="margin-right:0;margin-left:0;">
        <label class="control-label">Data do parecer jurídico</label>
        <div class="input-group">
          <!-- Alteração da exibição das datas CMJ nas telas de Projeto. Suporte 63.555 -->
          <input v-if="this.$router.currentRoute.name === 'projeto'" type="date" class="form-control" ref="dataParecerJuridico" name="data do parecer juridico" v-model="analise.dt_data_parecer_juridico"
               data-vv-as="data do parecer juridico" v-validate="'required|dateeqpast'">


        <input v-else type="text" class="form-control" ref="dataParecerJuridico" name="data do parecer juridico" v-model="analise.dt_data_parecer_juridico"
               placeholder="__ /__ /____" v-mask="'##/##/####'" data-vv-as="data do parecer juridico" v-validate="'required|dateeqpast|date_format:dd/MM/yyyy|after:dataCMJ,true'">
        </div>
        <span v-if="errors.first('data do parecer juridico')" class="label label-danger"> {{ errors.first('data do parecer juridico') }}</span>
      </div>

      <div class="form-group col-md-3 required-field" :class="{ 'has-error' : errors.first('número do parecer jurídico')}" style="margin-right:0;margin-left:0;">
        <label class="control-label">Número do parecer jurídico</label>
        <input v-model="analise.ds_parecer_juridico" name="número do parecer jurídico"
               class="form-control" type="text"
               placeholder="Número do parecer jurídico" v-validate="'required|max:255'">
        <span v-if="errors.first('número do parecer jurídico')" class="label label-danger"> {{ errors.first('número do parecer jurídico') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   * Campos do Parecer jurídico (Data/Número do CMJ e do parecer jurídico).
   * Extraído para ser reutilizado em duas posições: standalone (produção) e
   * dentro do Checklist da Análise, antes do grupo "Enquadramento e Parecer
   * Jurídico" (dev/homologação). Grava nas colunas legadas da tb_proposta
   * (analise.ds_cmj, analise.dt_data_cmj, ...).
   *
   * Compartilha o $validator do formulário pai (vee-validate) para que as
   * validações participem do fluxo de Concluir.
   */
  export default {
    name: 'parecerJuridicoCampos',
    inject: ['$validator'],
    props: ['analise']
  }
</script>



// WEBPACK FOOTER //
// parecerJuridicoCampos.vue?7f619c35